import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { geoLocationApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${geoLocationApiUrl()}/api/v2/`;

export default createScopedApi(BASE_API_URL, axiosInstance);
